module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8ec069e13e90bb47735837abc3e07cb7.png";